import React, { memo } from 'react';
import { Referral } from '..';

type Props = {
    referral: Referral;
}

export const ScheduleNotesRenderer = memo(function ScheduleNotesRenderer({ referral }: Props) {
    const { scheduleNotes } = referral;

    if (!scheduleNotes) {
        return 'None';
    }

    return (
        <>
            { scheduleNotes?.split('\n').map((i, key) => {
                return <div className='pb-2' key={ key }>{ i }</div>;
            }) }
        </>
    )
})